module.exports = __webpack_public_path__ + "img/playlist.035d745d.svg";